import SocialIcons from '@components/ui/SocialIcons'
import cn from 'clsx'
import Image from "next/legacy/image"

interface Props {
  slice: any
}

const HomepageSocialmedia = ({ slice }: Props) => {
  return (
    <section>
      <div className="w-full bg-white">
        <div className="wrapper py-14">
          <div className="flex items-center justify-center lg:mb-10 lg:justify-between">
            <div className="heading-mobile-4 lg:heading-4 pb-8 text-center font-roboto font-light text-brand-dark-grey lg:pb-0 lg:text-left">
              {slice.primary.title}
            </div>
            <div className="hidden items-center lg:block">
              <SocialIcons width={24} height={24} fill="#646464" />
            </div>
          </div>

          <div className="flex md:justify-center lg:justify-start">
            <div className="grid grid-cols-6 gap-x-4 gap-y-4 text-img md:grid-cols-2 lg:ml-0 lg:grid-cols-6 lg:grid-rows-2 lg:gap-x-8 ">
              {slice.items?.map((item: any, index: number) => {
                const ImageUrl = item?.image?.url
                const linkUrl = item?.link || '/'
                if (ImageUrl) {
                  if ([0, 1, 4, 5].includes(index)) {
                    return (
                      <div
                        key={`${ImageUrl}${index}`}
                        className="md:max-w-48 col-span-3 row-span-1 overflow-hidden md:col-span-2 md:mb-4 md:max-h-48 md:text-img lg:col-span-1"
                      >
                        <div className="cursor-pointer">
                          <a href={linkUrl} target="_blank" rel="noreferrer">
                            <Image
                              src={ImageUrl}
                              alt="Image"
                              width={192}
                              height={192}
                            />
                          </a>
                        </div>
                      </div>
                    )
                  } else {
                    return (
                      <div
                        key={`${ImageUrl}${index}`}
                        className={cn(
                          'md:max-w-104 col-span-6 row-span-2 overflow-hidden md:col-span-4 md:mb-4 md:max-h-104 lg:col-span-2 lg:mb-0 xl:h-104 ',
                          {
                            'hidden lg:block': index === 3,
                          }
                        )}
                      >
                        <div className="cursor-pointer">
                          <a href={linkUrl} target="_blank" rel="noreferrer">
                            <Image
                              src={ImageUrl}
                              alt="Image"
                              width={416}
                              height={416}
                            />
                          </a>
                        </div>
                      </div>
                    )
                  }
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default HomepageSocialmedia
